import { Navigate, Outlet } from 'react-router-dom'

import { RouteEnum } from '../../constants/routes.enum'
import { useUserStore } from '../../entities/user/stores/user.store'

const PrivateRoute = () => {
  const user = useUserStore((state) => state.user)
  const isAuthenticated = Boolean(user?.token)

  if (!isAuthenticated) {
    return <Navigate to={`/${RouteEnum.AUTH}`} />
  }

  return <Outlet />
}

export default PrivateRoute
